import React from 'react';
import InfoCard from '../InfoCard/InfoCard';

const typeStyleMap = {
  // subtotal = 0
  0: {
    color: '#5e5c5c',
    fontSize: '13px',
  },
  // shipping = 1
  1: {
    color: '#5e5c5c',
    fontSize: '13px',
  },
  // total = 2
  2: {
    color: '#000000',
    fontSize: '13px',
  },
  // PE Discount = 3
  3: {
    color: '#16866e',
    fontSize: '13px',
  },
  // Promotional Discount = 5
  5: {
    color: '#16866e',
    fontSize: '13px',
  },
};

const AmountBifurcation = ({ invoice }) => (
  <div className="AmountBifurcation">
    {invoice.map(el => (
      <div key={el.text}>
        <div className="keyContainer" style={typeStyleMap[el.type]}>
          <div>{el.text}</div>
          <InfoCard infoCard={el.infoCard} />
          <div>
            {el.displayValue || el.finalValue}
            {!!el.disclaimer && (
              <span >&nbsp;({el.disclaimer.text})</span>
            )}
          </div>
        </div>
      </div>
    ))}
  </div>
  );

export default AmountBifurcation;
